"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _makeStyles = _interopRequireDefault(require("@material-ui/core/styles/makeStyles"));

var _classnames = _interopRequireDefault(require("classnames"));

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    root: {
      backgroundColor: theme.palette.common.white,
      borderRadius: 6,
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: theme.palette.grey[500],
      paddingTop: 16,
      paddingBottom: 16,
      paddingRight: 20,
      paddingLeft: 20,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      transition: theme.transitions.create(["border-color", "border-width", "padding"], {
        duration: theme.transitions.duration.standard
      })
    },
    selected: {
      borderWidth: 2,
      borderColor: theme.palette.secondary.main
    },
    disabled: {
      borderWidth: 1,
      borderColor: theme.palette.grey[500],
      backgroundColor: theme.palette.grey[100]
    },
    ripple: {
      backgroundColor: theme.palette.secondary.main
    }
  };
});
/**
 * ** These are the containers used to create the Selector component. **
 *
 * There are 2 states: Selected, Disabled
 */

var PickerContainer = function PickerContainer(_ref) {
  var _classNames;

  var children = _ref.children,
      selected = _ref.selected,
      disabled = _ref.disabled,
      action = _ref.action;
  var styles = useStyles();
  return /*#__PURE__*/_react.default.createElement(_core.ButtonBase, {
    onClick: function onClick(event) {
      return action(event);
    },
    className: (0, _classnames.default)((_classNames = {}, _defineProperty(_classNames, styles.root, true), _defineProperty(_classNames, styles.selected, selected), _defineProperty(_classNames, styles.disabled, disabled), _classNames)),
    disabled: disabled,
    TouchRippleProps: {
      classes: {
        child: styles.ripple
      }
    }
  }, children);
};

PickerContainer.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.node]),

  /** The selected state of the picker */
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,

  /** Action to call when click the picker */
  action: _propTypes.default.func.isRequired
};
PickerContainer.defaultProps = {
  selected: false,
  disabled: false,
  children: null
};
var _default = PickerContainer;
exports.default = _default;